export const apiUrls: any = {
  baseUrl: process.env.REACT_APP_API_URL,
  localBaseUrl: process.env.REACT_APP_API_URL,
  openApiUrl: process.env.REACT_APP_OPENAPI_URL,
  localOpenApiUrl: process.env.REACT_APP_OPENAPI_URL,
  live: {
    login: {
      login: {
        url: "/login",
        version: "/v1",
        requestType: "POST",
      },
      getAuthkeys: {
        url: "/getAuthKeys",
        version: "/v1",
        requestType: "GET",
      },
      logout: {
        url: "/logout",
        version: "/v1",
        requestType: "POST",
      },
      authenticateByAzureAD: {
        url: "/authenticateByAzureAD",
        version: "/v1",
        requestType: "GET",
      },
      getAzureADRefreshToken: {
        url: "/getAzureADRefreshToken",
        version: "/v1",
        requestType: "POST",
      },
      authCookiesToken: {
        url: "/authCookiesToken",
        version: "/v1",
        requestType: "POST",
      },
      initAzure: {
        url: "/initAzure",
        version: "/v1",
        requestType: "POST",
      },
      checkSessionInfo: {
        url: "/checkSessionInfo",
        version: "/v1",
        requestType: "GET",
      },
      getOktaToken: {
        url: "/getOktaToken",
        version: "/v1",
        requestType: "GET",
      },
    },
    userPermission: {
      getuserPrivilege: {
        url: "/userPrivilege",
        version: "/v1",
        requestType: "GET",
      },
      getAuditLogDetail: {
        url: "/roleprivilege/getRoleAuditLog",
        version: "/v1",
        requestType: "GET",
      },
      getAuditLogSearchField: {
        url: "/privileges/GET",
        version: "/v1",
        requestType: "GET",
      },
      getUserPreferences:{
        url: "/getGridUserPreferences",
        version: "/v1",
        requestType: "GET",
      },
      updateGridPreferences:{
        url: "/updateGridPreferences",
        version: "/v1",
        requestType: "PUT",
      }
    },
    openAPI: {
      flagFeature: {
        url: "/master/featureflag",
        version: "/v1",
        requestType: "GET",
      },
      downloadUrl: {
        url: "/document/ballot",
        version: "/v1",
        requestType: "GET",
      },
      getBallotItemsDownloadUrl: {
        url: "/document/ballotitem/search",
        version: "/v1",
        requestType: "GET",
      },
      createNewFolder: {
        url: "/document/createBallotFolder",
        version: "/v1",
        requestType: "POST",
      },
      moveDocuments: {
        url: "/document/move",
        version: "/v1",
        requestType: "POST",
      },
      documentInfo: {
        url: "/document/searchByGuid",
        version: "/v1",
        requestType: "GET",
      },
      documentInfoV1_1: {
        url: "/document/searchByGuid",
        version: "/v1.1",
        requestType: "POST",
      },
      downloadDocument: {
        url: "/document/Url",
        version: "/v1.1",
        requestType: "POST",
      },
      getUplaodToken: {
        url: "/document/uploadToken",
        version: "/v1",
        requestType: "GET",
      },
      getUploadSessionUrl: {
        url: "/document/UploadSessionUrl",
        version: "/v2",
        requestType: "POST",
      },
      saveMetaData: {
        url: "/document/Info",
        version: "/v2",
        requestType: "POST",
      },
      getBallotFolderDetail: {
        url: "/document/BallotFolder",
        version: "/v1",
        requestType: "GET",
      },
      documentWebURL: {
        url: "/document/Url",
        version: "/v1.1",
        requestType: "POST",
      },
      convertFile: {
        url: "/document/ConvertFile",
        version: "/v1",
        requestType: "POST",
      },
      deleteBallotDocument: {
        url: "/document",
        version: "/v2",
        requestType: "DELETE",
      },
      cancelBallotFolder: {
        url: "/document/cancelBallotFolder",
        version: "/v1",
        requestType: "DELETE",
      },
      updateBallotStatus: {
        url: "/document/updateBallotStatus",
        version: "/v2",
        requestType: "PUT",
      },
      getDocumentInfo:{
        url: "/document",
        version: "/v1",
        requestType: "GET",
      },
      updateRepublish:{
        url: "/document/BallotFolder/UpdateRepublish",
        version: "/v1",
        requestType: "PUT",
      },
      getBallotfolderStatus:{
        url: "/document/BallotFolder/GetBallotfolderStatus",
        version: "/v1",
        requestType: "GET",
      },
      ballotRecallToPrePublish: {
        url: "/document/ballotRecallToPrePublish",
        version: "/v2",
        requestType: "PUT",
      }
    },
    documents: {
      getBallotsList: {
        url: "/ballotHeader",
        version: "/v1",
        requestType: "GET",
      },
      getActiveCommittees: {
        url: "/getActiveCommittees",
        version: "/v1",
        requestType: "GET",
      },
      getBallotTypes: {
        url: "/getBallotTypes",
        version: "/v1",
        requestType: "GET",
      },
      getActiveCommitteesFromIA: {
        url: "/getActiveCommittees",
        version: "/v1",
        requestType: "GET",
      },
      saveBallotHeader: {
        url: "/ballotHeader/saveBallotHeader",
        version: "/v1",
        requestType: "POST",
      },
      getAllBallotStatus: {
        url: "/getAllBallotStatus",
        version: "/v1",
        requestType: "GET",
      },
      getAppUserList: {
        url: "/getAppUserList",
        version: "/v1",
        requestType: "GET",
      },
      getWorkItemList: {
        url: "/workItemMgmt",
        version: "/v1",
        requestType: "GET",
      },
      getWorkDetailList: {
        url: "/workItemMgmt/workItemDetail/",
        version: "/v1",
        requestType: "GET",
      },
      getStandardTypeList: {
        url: "/workItemAdmin/standardTypes",
        version: "/v1",
        requestType: "GET",
      },
      getBallotTracking: {
        url: "/ballotItem/getBallotTracking",
        version: "/v1",
        requestType: "GET",
      },
      getSNBallotTracking: {
        url: "/ballotItem/getSNBallotTracking",
        version: "/v1",
        requestType: "GET",
      },
      getBallotDesignation: {
        url: "/getBallotDesignation",
        version: "/v1",
        requestType: "GET",
      },
      addItemToBallotTracking: {
        url: "/ballotItem/addItemToBallotTracking",
        version: "/v1",
        requestType: "POST",
      },
      draftAction: {
        url: "/draftAction",
        version: "/v1",
        requestType: "GET",
      },
      deleteBallotItem: {
        url: "/deleteBallotItem",
        version: "/v1",
        requestType: "POST",
      },
      checkMimeType: {
        url: "/validateContentType",
        version: "/v1",
        requestType: "POST",
      },
      uploadBallotDocument: {
        url: "/uploadBallotDocument",
        version: "/v1",
        requestType: "POST",
      },
      updateBallotTrackingSequence: {
        url: "/ballotItem/Sequence/updateBallotTrackingSequence",
        version: "/v1",
        requestType: "PUT",
      },
      sendItemToQueue: {
        url: "/sendItemToQueue",
        version: "/v1",
        requestType: "Post",
      },
       getBallotDesignationList: {
        url: "/getBallotDesignationList",
        version: "/v1",
        requestType: "GET",
      },
      captureBallotAuditLog: {
        url:"/captureBallotAuditLog",
        version: "/v1",
        requestType: "GET",
      }
    },
    ballotItem:{
      removeBallotItem: {
        url: "/ballotItem/removeBallotItem",
        version: "/v1",
        requestType: "DELETE",
      }
    },
    workItems: {
      getDraftsList: {
        url: "/getDraftsList",
        version: "/v1",
        requestType: "POST",
      },
      getDraftBallotHistory: {
        url: "/workItems/getDraftBallotHistory",
        version: "/v1",
        requestType: "POST",
      },
      deleteWITN: {
        url: "/workitemTrackingNumber",
        version: "/v1",
        requestType: "DELETE",
      },
      getProcessWorkitem: {
        url: "/processWorkItem",
        version: "/v1",
        requestType: "POST",
      },
      processAdminWorkItem: {
        url: "/workItemMgmt/processAdminWorkItem",
        version: "/v1",
        requestType: "POST",
      },
      getWorkItemStatus: {
        url: "/workItemStatus",
        version: "/v1",
        requestType: "GET",
      },
      getWorkItemType: {
        url: "/workItemType",
        version: "/v1",
        requestType: "GET",
      },
      getWorkItems: {
        url: "/getWorkItems",
        version: "/v1",
        requestType: "GET",
      },
      getWorkItemList: {
        url: "/getWorkItemList",
        version: "/v1",
        requestType: "POST",
      },
      getDraftActionList :{
        url: '/Draft/draftaction',
        version: '/V1',
        requestType: "GET",
      },
      getAllStandardTypesAction: {
        url: '/allStandardTypes',
        version: '/v1',
        requestType: 'GET'
      },
      getReplacementDesignations:{
        url: '/GetReplacementDesignations',
        version: '/v1',
        requestType: 'GET'
      },
      editWorkItemTracking: {
        url: "/workitemTrackingNumber",
        version: "/v1",
        requestType: "PUT",
      },
      updateWITNAdminHold: {
        url: "/workitemTrackingNumber/hold",
        version: "/v1",
        requestType: "POST",
      },
      getCommitteeOfficerTitle: {
        url: "/getCommitteeOfficerTitle",
        version: "/v1",
        requestType: "POST",
      }
      
    },
    ballots: {
      getCommitteeBallotItems: {
        url: "/ballotQueue",
        version: "/v1",
        requestType: "GET",
      },
      getDraftList: {
        url: "/getDraftList",
        version: "/v1",
        requestType: "POST",
      },
      getDraftListOnStatus: {
        url: "/getDraftListOnStatus",
        version: "/v1",
        requestType: "get",
      },
      getStandardMaintDesignationList: {
        url: "/getStandardMaintDesignationList",
        version: "/v1",
        requestType: "GET",
      },
      ballotRecapList: {
        url: "/ballotRecapList",
        version: "/v1",
        requestType: "GET",
      },
      addQuickBallotItem: {
        url: "/ballotItem/addQuickBallotItem",
        version: "/v1",
        requestType: "POST",
      },
      updateBallotTracking: {
        url: "/ballotItem/updateBallotTracking",
        version: "/v1",
        requestType: "PUT",
      },
      cancelBallotFolder: {
        url: "/document/cancelBallotFolder",
        version: "/v1",
        requestType: "DELETE",
      },
      getDate: {
        url: "/getDate",
        version: "/v1",
        requestType: "GET",
      },
      validateBallotOpenProcess: {
        url: "/validateBallotOpenProcess",
        version: "/v1",
        requestType: "GET",
      },
      validateBallotItemPreparationProcess: {
        url: "/validateBallotItemPreparationProcess",
        version: "/v1",
        requestType: "GET",
      },
      postValidateBallotItemPreparationProcess: {
        url: "/postValidateBallotItemPreparationProcess",
        version: "/v1",
        requestType: "POST",
      },
      publishBallot: {
        url: "/publishBallot",
        version: "/v1",
        requestType: "POST",
      },
      createWorkItemTracking: {
        url: "/workitemTrackingNumber",
        version: "/v1",
        requestType: "POST",
      },
      voterListAction: {
        url: "/voterSummaryList",
        version: "/v1",
        requestType: "POST",
      },
      voteDetail: {
        url: "/voteDetail",
        version: "/v1",
        requestType: "GET",
      },
      updateBallotQueue: {
        url: "/ballotQueue/updateBallotQueue",
        version: "/v1",
        requestType: "PUT",
      },
      deleteBallotQueue: {
        url: "/ballotQueue",
        version: "/v1",
        requestType: "DELETE",
      },
      submitBallotVote: {
        url: "/submitBallotVote",
        version: "/v1",
        requestType: "POST",
      },
      updateBallotVote: {
        url: "/updateBallotVote",
        version: "/v1",
        requestType: "PUT",
      },
      addBallotQueue:{
        url:"/ballotQueue/addBallotQueue",
        version: "/v1",
        requestType: "POST",
      },
      UpdateBallotQueueMetaData:{
        url:"/updateBallotQueueMetaData",
        version: "/v1",
        requestType: "PUT",
      },
      getBallotDetail: {
        url:"/ballotItem/ballotDetail",
        version: "/v1",
        requestType: "GET",
      },
      recallBallot: {
        url:"/ballotPrePublishProcess",
        version:"/v1",
        requestType:"POST"
      },
      ballotAuditLogs: {
        url:"/ballotAuditLogs",
        version:"/v1",
        requestType:"GET"
      },
      getDraftDependency: {
        url:"/DraftDependency",
        version:"/v1",
        requestType:"GET"
      },
      updateDraftDependency: {
        url:"/workitemTrackingNumber/dependency",
        version:"/v1",
        requestType:"POST"
      },
      validateBallotForceClose:{
        url:"/ValidateBallotForceClose",
        version:"/v1",
        requestType:"GET"
      },
      ballotForcedCloseProcess :{
        url:"/ballot/ballotForcedCloseProcess",
        version:"/v1",
        requestType:"POST"
      },
      getDesignations:{
        url: '/getDesignations',
        version: '/v1',
        requestType: 'POST'
      },
      getDraftListOnDesignation:{
        url: '/getDraftListOnDesignation',
        version: '/v1',
        requestType: 'GET'
      },
      getCommitteeFlyoverCount: {
        url: '/getCommitteeFlyoverCount',
        version: '/v1',
        requestType: 'GET'
      },
      getBallotItemInformation: {
        url: '/getBallotItemInformation',
        version: '/v1',
        requestType: 'POST'
      },
      getNegativeRulingRationale: {
        url: '/getNegativeRulingRationale',
        version: '/v1',
        requestType: 'POST'
      },
      getAwsDoc: {
        url: '/getAwsDoc',
        version: '/v1',
        requestType: 'POST'
      },
      getUploadPresignedUrl:{
       url: "/getUploadPresignedUrl",
        version: "/v1",
        requestType: "POST",
      },
      putReactivateOnr:{
        url: "/ballot/putReactivateOnr",
        version: "/v1",
        requestType: "PUT",
      }
    },
    workItemAdmin: {
      workItemDetails: {
        url: "/workItemAdmin/workItemDetail/",
        version: "/v1",
        requestType: "GET",
      },
      standardTypeList: {
        url: "/workItemAdmin/standardTypes",
        version: "/v1",
        requestType: "GET",
      },
      updateWorkItemDetails: {
        url: "/workItemMgmt",
        version: "/v1",
        requestType: "PUT",
      },
      deleteWorkItem: {
        url: "/workItemMgmt/Delete",
        version: "/v1",
        requestType: "PUT",
      },
      restoreWorkItem: {
        url: "/workItemMgmt/recoverWorkItem/",
        version: "/v1",
        requestType: "PUT",
      },
      deletedWorkItemList: {
        url: "/workItemAdmin/viewDeletedWorkItem",
        version: "/v1",
        requestType: "POST",
      },
      workItemAuditLogs: {
        url: "/workItemMgmt/workItemAuditLogs",
        version: "/v1",
        requestType: "GET",
      },
      witnAuditLogs: {
        url: "/workitemTrackingNumber/witnAuditLogs",
        version: "/v1",
        requestType: "GET",
      },
      getSubCommitteesList: {
        url: "/workItemAdmin/getSubCommitteeList/",
        version: "/v1",
        requestType: "GET",
      },
      getMemberList: {
        url: "/workItemAdmin/getMemberList/",
        version: "/v1",
        requestType: "GET",
      },
      getBallotItemSubmissionList: {
        url: "/workItemAdmin/getBallotItemSubmissionList",
        version: "/v1",
        requestType: "GET",
      },
      getPreReleaseTargetDateList: {
        url: "/workItemAdmin/getPreReleaseTarget/",
        version: "/v1",
        requestType: "PUT",
      },
      auditLog: {
        url: "/workItemAdmin/workItemAuditLog",
        version: "/v1",
        requestType: "POST",
      },
      sendCollabApiFailureEmail: {
        url: "/workItemAdmin/sendCollabApiFailureEmail",
        version: "/v1",
        requestType: "POST",
      },
      getDraftDetailAction: {
        url: "/getDraftDetailAction",
        version: "/v1",
        requestType: "POST",
      },
      deleteADWorkItem: {
        url: "/workItemMgmt/deleteADWorkItem",
        version: "/v1",
        requestType: "POST",
      },
      getWIDetailOnWITN: {
        url: "/workItemMgmt/getWIDetailOnWITN",
         version: "/v1",
        requestType: "GET",
      }
    },
    member: {
      getActiveCommittees: {
        url: "/getActiveCommittee",
        version: "/v1",
        requestType: "GET",
      },
      getAllCommittees: {
        url: "/getAllCommittee",
        version: "/v1",
        requestType: "GET",
      },
      getAllMembers: {
        url: "/getAllMember",
        version: "/v1",
        requestType: "GET",
      },
    },
    ansi: {
      getANSICommitteeList: {
        url: "/ansiDetails/committee",
        version: "/v1",
        requestType: "GET",
      },
      getANSIStandardList: {
        url: "/ansiDetails/standard",
        version: "/v1",
        requestType: "GET",
      },
      getStandardANSIDocumentList: {
        url: "/ansiDetails/StandardANSIDocumentList",
        version: "/v1",
        requestType: "GET",
      },
      updateANSIBSR108: {
        url: "/updateANSIBSR108",
        version: "/v1",
        requestType: "PUT",
      },
      updateANSICommitteeStandard: {
        url: "/ansiDetails",
        version: "/v1",
        requestType: "PUT",
      },
      deleteANSICommitteeStandard: {
        url: "/ansiDetails",
        version: "/v1",
        requestType: "DELETE",
      },
      getStandardANSIApprovalList: {
        url: "/ansiDetails/approvalList",
        version: "/v1",
        requestType: "GET",
      },
      updateANSIStandardApproval: {
        url: "/ansiDetails/approvalList",
        version: "/v1",
        requestType: "PUT",
      },
      getExportANSIStandardList: {
          url: "/ansiDetails/export/standard",
          version: "/v1",
          requestType: "GET",
      },
      getExportANSICommitteeList: {
          url: "/ansiDetails/export/committee",
          version: "/v1",
          requestType: "GET",
      },
      ansiAuditLogs:{
        url: "/ansiDetails/ansiAuditLogs",
        version: "/v1",
        requestType: "GET",
      },
      addStandardANSIDocument:{
        url: "/ansiDetails/addStandardANSIDocument",
        version: "/v1",
        requestType: "POST",
      },
      deleteBSRFile: {
        url: '/ansiDetails/BSR108File',
        version: '/v1',
        requestType: 'Delete'
      }
  },
  local: {
    login: {
      login: {
        url: "/login",
        version: "/v1",
        requestType: "GET",
      },
    },
  },
}
};

function getApiUrl(key: any, name: any, isOpenAPICall: any = false) {
  let url;
  const baseURL: any = isOpenAPICall === true ? apiUrls.openApiUrl : apiUrls.baseUrl;
  if (baseURL !== null) {
    if (apiUrls.live[key] && apiUrls.live[key][name]) {
      url = baseURL + apiUrls.live[key][name]["version"] + apiUrls.live[key][name]["url"];
    } else {
      if (apiUrls.local[key] && apiUrls.local[key][name]) {
        const localURL = isOpenAPICall === true ? apiUrls.localOpenApiUrl : apiUrls.openApiUrl;
        url = localURL + apiUrls.local[key][name]["version"] + apiUrls.local[key][name]["url"];
      }
    }
  } else {
    if (apiUrls.local[key] && apiUrls.local[key][name]) {
      const localURL = isOpenAPICall === true ? apiUrls.localOpenApiUrl : apiUrls.openApiUrl;
      url = localURL + apiUrls.local[key][name]["version"] + apiUrls.local[key][name]["url"];
    }
  }
  return url;
}

export default getApiUrl;
